import { createFileRoute } from '@tanstack/react-router';
import {
  loadProductRulesMessages,
  loadProductRulesScreens,
  ruleProductsScreen,
  ruleProductsSearch,
} from '@/modules/credit-product-rules/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

export const Route = createFileRoute('/_app/cadastro/configuracao-regras/$ruleId/produtos/')({
  validateSearch: ruleProductsSearch,
  staticData: { screen: ruleProductsScreen },
  loader: () => loadProductRulesMessages(),
  component: lazyScreen(loadProductRulesScreens, 'RuleProductsPage'),
});
